<script lang="ts">
	import { Dialog as DialogPrimitive } from 'bits-ui'
	import { cn } from 'tailwind-variants'

	let {
		ref = $bindable(null),
		class: className,
		...restProps
	}: DialogPrimitive.DescriptionProps = $props()
</script>

<DialogPrimitive.Description
	class={cn(
		'text-muted-foreground *:[a]:hover:text-foreground text-sm *:[a]:underline *:[a]:underline-offset-3',
		className
	)}
	data-slot="dialog-description"
	bind:ref
	{...restProps}
/>
